import { createContext } from "react";
import { User } from "../Types/User"
import { IGrupos_Homo_Eficiencia_Alimentar } from "../Interfaces/eficiencia_alimentar/plano_de_alimentacao";

interface signin_interface {
    flag: Boolean,
}

export type AuthContextType = {
    user: User | null;
    user_role: string | null;
    id_agricultor_externo: number | null;
    nif_agricultor_from_caderno: string | null;
    nome_agricultor_from_caderno: string | null;
    id_rosto_from_caderno: number | null;
    idagri: number | null;
    id_identificacao_from_eficiencia: number | null;
    id_registo_caderno_eficiencia: number | null;
    lista_grupos_homo_eficiencia: IGrupos_Homo_Eficiencia_Alimentar[];
    refresh_grupos_homo_eficiencia: number;
    token: any;
    cor: string;
    cultura: string;
    is_historico: any;
    func_set_user_role: (role: string) => void;
    func_set_user: (token_obj: any) => void;
    func_set_id_agricultor_externo: (id: number | null) => void;
    func_setNif_agricultor_from_caderno: (nif_agri: any) => void;
    func_setNome_agricultor_from_caderno: (nome_agri: any) => void;
    func_setId_rosto_from_caderno: (id_rosto: any) => void;
    func_set_id_agricultor_para_eficiencia_alimentar: (idagri: any) => void;
    func_set_id_identificacao_from_eficiencia: (id_identificacao: any) => void;
    func_set_id_registo_caderno_eficiencia: (id_registo_caderno_eficiencia: any) => void;
    func_set_lista_grupos_homo_eficiencia: (lista_grupos_homo_eficien: IGrupos_Homo_Eficiencia_Alimentar[]) => void;
    signin: (dados: any) => Promise<signin_interface>
    signin_agricultor: (dados: any) => Promise<signin_interface>
    signout: () => void;
    func_set_cor: (cor: string) => void;
    func_set_cultura: (cultura: string) => void;
    func_set_is_historico: (is_historico: any) => void;


}

export const AuthContext = createContext<AuthContextType>(null!);